// src/lib/http.js
import axios from "axios";

const API = process.env.REACT_APP_API_URL;

if (!API) {
  console.warn(
    "API base URL is missing. Please set REACT_APP_API_URL in .env"
  );
}

const http = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

export default http;
